
import React from 'react';

const MissionSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our Mission
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              At The Simple MD, we're revolutionizing healthcare delivery in Miami and beyond. Our mission is to make high-quality medical care accessible, convenient, and personalized through cutting-edge virtual primary care and advanced wellness treatments.
            </p>

            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Compassionate Care</h3>
                  <p className="text-gray-600">We treat every patient with empathy, respect, and dignity, ensuring they feel heard and valued throughout their healthcare journey.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-microscope-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Medical Excellence</h3>
                  <p className="text-gray-600">Our commitment to the highest standards of medical practice drives us to continuously improve and innovate in patient care.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Collaborative Approach</h3>
                  <p className="text-gray-600">We believe in teamwork, working closely with patients and their families to develop personalized treatment plans.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Innovation</h3>
                  <p className="text-gray-600">We embrace cutting‑edge technology and evidence‑based practices to provide the most effective treatments available.</p>
                </div>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Why The Simple MD?
            </h3>
            <p className="text-gray-600 mb-6">
              Founded in Miami, Florida, The Simple MD represents a new paradigm in healthcare. We combine the convenience of virtual consultations with the expertise of board‑certified physicians and the latest in wellness technology.
            </p>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/735935db39947dc65ce961083fe14352.jpg"
              alt="Medical team collaboration"
              className="rounded-2xl shadow-2xl object-cover w-full h-[500px] object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">20+</div>
                <div className="text-sm text-gray-600">Years of Excellence</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
